// eslint-disable-next-line import/extensions -- package only exposes polyfill.js entry
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-pluralrules/locale-data/no';
import { flatten } from 'flat';
import no from './no.json';

export const getMessages = (): Record<string, string> => {
  // flatten will preserve dash keys as strings
  return flatten<typeof no, Record<string, string>>(no);
};
